import { render, staticRenderFns } from "./HeaderBox.vue?vue&type=template&id=42de6d36&"
import script from "./HeaderBox.vue?vue&type=script&lang=js&"
export * from "./HeaderBox.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBox.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports